<template>
  <modal
      name="contact-modal"
      :width="`100%`"
      :height="600"
      :pivotX="0.5"
      :pivotY="0.5"
      :delay="100"
      :clickToClose="false"
      @before-open="beforeOpen"
  >
    <vue-scroll>
    <div
        class="FloatMenu md_overlay md_overlay_0"
        style="overflow: auto;"
    >
      <div class="modal modal_0">
        <vue-scroll>
          <div class="md_content" style="width: 800px;">
            <h6 class="pb40 --blue70">
              {{ $t('menu.contact_us')}}
            </h6>
            <span class="md_close">
              <img
                  src="/images/union.svg"
                  alt=""
                  @click="modalClose"
              />
            </span>
            <BtnList
                :status="status"
                :deleteDisable="data.completeDate !== ''"
                @onChange="handleChange"
            />
            <div
                v-if="status === 'view'"
                class="view"
            >
              <KvTable :items="items"/>
            </div>
            <div
                v-else-if="status === 'write'"
                class="write"
            >
              <KvTable :items="items"/>
            </div>
            <div
                v-else
                class="list"
            >
              <ListTable
                  :headerItems="headerItems"
                  :itemRows="itemRows"
              />
            </div>
          </div>
        </vue-scroll>
      </div>
    </div>
    </vue-scroll>
    <LoadingOverlay
        :activeSyncProps="loading"
        :isFullPageProps="true"
    />
  </modal>
</template>
<script>
import BtnList from './btnList'
import ListTable from '@/components/Table/listTable'
import KvTable from "@/components/Table/kvTable";
import LoadingOverlay from "../../loadingOverlay";
import _API from "@/api";

export default {
  name: 'contact-modal',
  components: {
    BtnList,
    ListTable,
    KvTable,
    LoadingOverlay,
  },
  data() {
    return {
      status: 'list',
      headerItems: [
        {
          index: 0,
          keyTitle: this.$t('table.header.title'),
          keyType: 'HeaderDefault',
        },
        {
          index: 2,
          keyTitle: this.$t('table.header.date_time'),
          keyType: 'HeaderDefault',
        },
        {
          index: 3,
          keyTitle: `${this.$t('modal.answer')}${this.$t('unit.none')}${this.$t('unit.day')}`,
          keyType: 'HeaderDefault',
        },
      ],
      itemRows: [],
      data: {
        title: '',
        question: '',
        createDate: '',
        answer: '',
        completeDate: '',
      },
      items: [],
      loading: false,
    }
  },
  methods: {
    beforeOpen(e) {
      this.status = 'list';
      this.itemRows = [];

      this.loading = true;
      _API.USER.inquiryList()
          .then((r) => {
            const rtnData = r?.data?.inquiryList.map((item, index) => {
              const items = [];
              const inputData = {
                key: item?.seqBoard === undefined ? index : item?.seqBoard,
                title: item?.boardTitle,
                question: item?.boardContext,
                createDate: this.moment(item?.createDatetime).format('YYYY-MM-DD HH:mm'),
                answer: item?.replyList?.[0] === undefined ? '' : item?.replyList?.[0]?.boardReplyContext,
                completeDate: item?.replyList?.[0] === undefined ? '' : this.moment(item?.replyList?.[0]?.createDatetime).format('YYYY-MM-DD HH:mm'),
              }
              items.clickEvent = {
                func: (event, key, title, question, createDate, answer, completeDate) => {
                  this.data = {
                    key: key,
                    title: title,
                    question: question,
                    createDate: createDate,
                    answer: answer,
                    completeDate: completeDate,
                  };
                  this.status = 'view';
                },
                params: [
                  inputData.key,
                  inputData.title,
                  inputData.question,
                  inputData.createDate,
                  inputData.answer,
                  inputData.completeDate,
                ],
                key: inputData.key
              }
              items.push({
                index: 0,
                keyTitle: '',
                keyType: 'Default',
                class: [],
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: inputData.title,
              });
              items.push({
                index: 1,
                keyTitle: '',
                keyType: 'Default',
                class: [],
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: inputData.createDate,
              });
              items.push({
                index: 2,
                keyTitle: '',
                keyType: 'Default',
                class: [],
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: inputData.completeDate,
              });
              items.push({
                index: 3,
                keyTitle: '',
                keyType: 'Default',
                class: ['hidden'],
                componentOptions: {},
                keyRange: [],
                values: inputData.key
              });

              return items;
            })

            this.status = 'list';
            this.itemRows = rtnData;
          })
          .finally(() => {
            this.loading = false;
          })
    },
    modalClose: function () {
      this.$modal.hide('contact-modal');
    },
    handleChange(event, value, type) {
      if (type === 'save' || type === 'delete') {
        if (type === 'save' && (this.items[0].values === '' || this.items[1].values === '')) {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: this.$t(`account.empty_field`),
            function: () => {
            }
          });
        } else {
          this.$modal.show('yes-or-no-modal', {
            questionType: type,
            function: () => {
              this.loading = true;
              if (type === 'save') {
                _API.USER.inquirySave({
                  boardTitle: this.items[0].values,
                  boardContext: this.items[1].values,
                })
                    .then((r) => {
                      if (r.data.isSuccess) {
                        const inputData = {
                          key: this.itemRows.length,
                          title: this.items[0].values,
                          question: this.items[1].values,
                          createDate: this.moment(new Date()).format('YYYY-MM-DD HH:mm'),
                          answer: '',
                          completeDate: '',
                        }
                        const items = [];
                        items.clickEvent = {
                          func: (event, key, title, question, createDate, answer, completeDate) => {
                            this.data = {
                              key: key,
                              title: title,
                              question: question,
                              createDate: createDate,
                              answer: answer,
                              completeDate: completeDate,
                            };
                            this.status = 'view';
                          },
                          params: [
                            inputData.key,
                            inputData.title,
                            inputData.question,
                            inputData.createDate,
                            inputData.answer,
                            inputData.completeDate,
                          ],
                          key: inputData.key
                        }
                        items.push({
                          index: 0,
                          keyTitle: '',
                          keyType: 'Default',
                          class: [],
                          parentClass: [],
                          componentOptions: {},
                          keyRange: [],
                          values: inputData.title,
                        });
                        items.push({
                          index: 1,
                          keyTitle: '',
                          keyType: 'Default',
                          class: [],
                          parentClass: [],
                          componentOptions: {},
                          keyRange: [],
                          values: inputData.createDate,
                        });
                        items.push({
                          index: 2,
                          keyTitle: '',
                          keyType: 'Default',
                          class: [],
                          parentClass: [],
                          componentOptions: {},
                          keyRange: [],
                          values: inputData.completeDate
                        });
                        items.push({
                          index: 3,
                          keyTitle: '',
                          keyType: 'Default',
                          class: ['hidden'],
                          componentOptions: {},
                          keyRange: [],
                          values: inputData.key
                        });

                        this.itemRows = [
                          items,
                          ...this.itemRows,
                        ];

                        this.$modal.show('common-alert-modal', {
                          messageType: 'short',
                          message: this.$t(`alert.${type}_completed`),
                          function: () => {
                            this.status = value;
                          }
                        });
                      } else {
                        throw 'error'
                      }
                    })
                    .catch(() => {
                      this.$modal.show('common-alert-modal', {
                        messageType: 'short',
                        message: this.$t(`alert.unexpected_error`),
                        function: () => {
                          this.status = value;
                        }
                      });
                    })
                    .finally(() => {
                      this.loading = false;
                    })
              } else if (type === 'delete') {
                _API.USER.inquiryDelete(this.data.key)
                    .then((r) => {
                      if (r.data.isSuccess) {
                        this.itemRows = this.itemRows.filter(items => items[3].values !== this.data.key)

                        this.$modal.show('common-alert-modal', {
                          messageType: 'short',
                          message: this.$t(`alert.${type}_completed`),
                          function: () => {
                            this.status = value;
                          }
                        });
                      } else {
                        throw 'error'
                      }
                    })
                    .catch(() => {
                      this.$modal.show('common-alert-modal', {
                        messageType: 'short',
                        message: this.$t(`alert.unexpected_error`),
                        function: () => {
                          this.status = value;
                        }
                      });
                    })
                    .finally(() => {
                      this.loading = false;
                    })
              }
            },
          })
        }
      } else {
        this.status = value;
      }
    }
  },
  watch: {
    status: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === 'view') {
            this.items = [
              {
                index: 0,
                keyTitle: this.$t('table.header.title'),
                keyType: 'Default',
                class: [],
                parentClass: [],
                keyRange: [],
                values: this.data.title,
                maxLength: 60,
              },
              {
                index: 1,
                keyTitle: this.$t('table.header.date_time'),
                keyType: 'Default',
                class: [],
                keyRange: [],
                values: this.data.createDate,
              },
              {
                index: 2,
                keyTitle: this.$t('table.header.content'),
                keyType: 'Default',
                class: [],
                parentClass: ['columns_2', 'flex-col',],
                keyRange: [],
                values: this.data.question,
                maxLength: 4000,
              },
              {
                index: 3,
                keyTitle: `${this.$t('modal.answer')}${this.$t('unit.none')}${this.$t('unit.day')}`,
                keyType: 'Default',
                class: [],
                parentClass: ['columns_2',],
                keyRange: [],
                values: this.data.completeDate,
              },
              {
                index: 4,
                keyTitle: this.$t('modal.answer'),
                keyType: 'Default',
                class: [],
                parentClass: ['columns_2', 'flex-col',],
                keyRange: [],
                values: this.data.answer,
                maxLength: 4000,
              },
            ]
          } else if (newValue === 'write') {
            this.items = [
              {
                index: 0,
                keyTitle: this.$t('table.header.title'),
                keyType: 'DefaultInput',
                class: [],
                parentClass: ['columns_2'],
                keyRange: [],
                values: '',
                maxLength: 40,
              },
              {
                index: 3,
                keyTitle: this.$t('table.header.content'),
                keyType: 'textArea',
                class: ['height'],
                parentClass: ['columns_2', 'flex-col',],
                keyRange: [],
                values: '',
                maxLength: 4000,
              },
            ]
          } else {
            this.items = [];
          }
        }
      }
    },
  },
}
</script>
<style lang="scss">
.v--modal-overlay[data-modal="contact-modal"] {
  .md_content {
    .table-container {
      .hidden{
        display: none;
      }

      .table-header {
        position: sticky;
        top: 0;
        background: #f7f7f7;

        .item-value:first-child {
          flex-grow: 7;
        }
      }

      .item-parent {
        margin: 0;
      }
    }

    .view {
      flex: 7 7 5rem;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      justify-content: stretch;
      align-items: stretch;

      .table-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 50px auto 50px auto;
        width: 100%;
        overflow: hidden;
        flex: 1 1 1rem;

        .note_view_scroll {
          overflow: scroll;
        }

        .item-parent {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin: 0.5rem;
          text-align: left;
          border-bottom: 1px solid var(--grey20);
          padding-bottom: 15px;

          &.columns_2 {
            grid-column: 1/3;
          }

          .item-title {
            flex: 1 1 1rem;
            font-weight: 700;
          }

          .item-value {
            flex: 5 3 1rem;
          }

          &.flex-col {
            flex-direction: column;
            align-items: flex-start;
            overflow: hidden;

            .item-title {
              margin-bottom: 1rem;
              flex: 0 0 0;
            }

            .item-value {
              margin-bottom: 1rem;
              white-space: pre-line;
              width: 100%;
              overflow: auto;
            }
          }
        }
      }
    }

    .write {
      .item-parent {
        .item-title {
          flex: 1 1 1rem;
          font-weight: 700;
        }

        .item-value {
          flex: 14 3 1rem;
        }
      }

      textarea {
        margin-top: 10px;
        height: 280px;
      }
    }

    .list {
      overflow: auto;

      .item-value:first-child {
        flex-grow: 7;
      }
    }
  }
}
</style>